import { Component, createSignal, onCleanup } from "solid-js";
import DefaultAcordeon from "./DefaultAcordeon";
import Styles from "bundle-text:../styles/_domain.scss";
import { translations as t } from "../../../services/context";

interface DomainProps {
  onSelect: (domain: string) => void;
  domains: string[];
  isSubdomain?: boolean;
  totalDomains: number;
}

const Domain: Component<DomainProps> = (props) => {
  const [inputValue, setInputValue] = createSignal("");
  const [isDropdownOpen, setDropdownOpen] = createSignal(false);

  const handleSelect = (domain: string) => {
    setInputValue(domain);
    setDropdownOpen(false);
    props.onSelect(domain);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen());
  };

  const handleOutsideClick = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest(".wrapper")) {
      setDropdownOpen(false);
    }
  };

  // Fechar dropdown se clicar fora
  document.addEventListener("click", handleOutsideClick);
  onCleanup(() => document.removeEventListener("click", handleOutsideClick));

  return (
    <>
      <style>{Styles}</style>
      <DefaultAcordeon
        title={props.isSubdomain ? t["dns_subdomain"] : t["dns_domain"]}
        isOpen={true}
      >
        <div className="domain-content">
          <label for="domain">
            {props.isSubdomain
              ? t["dns_subdomain_text"]
              : t["dns_enter_select_domain"]}
          </label>

          <div class="wrapper" style="position: relative;">
            <div class="flex">
              <input
                id="domain"
                type="text"
                value={inputValue()}
                placeholder="Enter your external abc@xyz.com"
                onInput={(e) => setInputValue(e.currentTarget.value)}
              />
              <button
                type="button"
                onClick={toggleDropdown}
                classList={{ reverse: isDropdownOpen() }}
              >
                ▼
              </button>
            </div>

            {isDropdownOpen() && (
              <ul class="dropdown-list">
                {props.domains.map((domain) => (
                  <li onClick={() => handleSelect(domain)}>{domain}</li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </DefaultAcordeon>
    </>
  );
};

export default Domain;
